import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { AppState, ConfigService, pickContrastingTextColor } from '@gallaghercp/core-frontend';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'core-header-minimised',
    templateUrl: './header-minimised.component.html',
    styles: [],
    standalone: false,
})
export class HeaderMinimisedComponent implements OnInit, OnDestroy {
    private readonly config = inject(ConfigService);
    private readonly store = inject<Store<AppState>>(Store);
    private readonly destroyed = new Subject<void>();

    bgHeader?: string;
    borderHeader?: string;
    isDarkBg = true;

    ngOnInit(): void {
        this.updateHeaderBg();

        this.store
            .select(state => state.app)
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => {
                this.updateHeaderBg();
            });
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }

    private updateHeaderBg(): void {
        const colors = this.config.get('colors') as Record<string, any> | undefined;
        const configColors = this.config.get('configColors') as Record<string, any> | undefined;
        const loginPage = this.config.get('loginPage') as Record<string, any> | undefined;

        // Minimised / login header should match brand element background (#0c2340 in Ardent / Figma),
        // or explicit loginPage header config, not standard white top-nav headerBg
        this.bgHeader =
            loginPage?.['headerBackgroundColor'] ??
            colors?.['elementBackgroundColour'] ??
            configColors?.['elementBackgroundColour'] ??
            colors?.['secondary2'] ??
            configColors?.['secondary2'] ??
            colors?.['headerBg'] ??
            configColors?.['headerBg'] ??
            colors?.['footerBg'] ??
            configColors?.['footerBg'] ??
            '#0c2340';

        this.borderHeader =
            loginPage?.['headerBorderColor'] ??
            colors?.['footerTopBorder'] ??
            configColors?.['footerTopBorder'] ??
            colors?.['secondary'] ??
            colors?.['primary'] ??
            '#00b1e2';

        if (this.bgHeader && this.bgHeader !== 'transparent') {
            const contrast = pickContrastingTextColor(this.bgHeader);
            this.isDarkBg = contrast === 'white';
        }
    }
}
